import { ErrorScreen } from "@stenajs-webui/panels";
import * as React from "react";
import { HeadAgreementPanel } from "@/features/product-and-price/head-agreement/details/components/HeadAgreementPanel";
import { Outlet, useParams } from "react-router";
import { Helmet } from "react-helmet";

export interface CustomerHeadAgreementScreenParams {
  customerId: string;
  headAgreementId?: string;
}

export const CustomerHeadAgreementScreen: React.FC = () => {
  const { customerId, headAgreementId } = useParams() as {
    customerId: string;
    headAgreementId: string;
  };

  return (
    <>
      <Helmet title="Detail HA - Customer - FPP" />
      <HeadAgreementPanel
        customerId={customerId}
        headAgreementId={headAgreementId}
      />
      <Outlet />
    </>
  );
};
